import { defineComponent as _defineComponent } from 'vue'
import type { PlotRecommenderTitleFragment } from './GetPlotRecommenderTitles.query';

import { computed, ref } from 'vue';

import GridBuyBox from '@/features/buybox/components/grid/GridBuyBox.vue';

import PlotRecommenderTrailerModal from './PlotRecommenderTrailerModal.vue';
import PosterGraphql from '@/components/poster/PosterGraphql.vue';
import { ModalHelper } from '@/helpers/vfm/modal-helper';
import BasicButton from '@/ui-components/BasicButton.vue';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { useMediaQuery } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommenderTitleCard',
  props: {
    title: null,
    matchingScore: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { title: PlotRecommenderTitleFragment, matchingScore: number };



const userStore = useUserStore();

const isDescriptionExpanded = ref(false);
const isMobileViewport = useMediaQuery('(max-width: 767px)');

const badgeColor = computed(() => {
	if (props.matchingScore >= 0 && props.matchingScore < 50) {
		return '#A30000';
	}
	if (props.matchingScore >= 50 && props.matchingScore < 60) {
		return '#DD7E00';
	}
	if (props.matchingScore >= 60) {
		return '#339B2A';
	}
	return ''; // default color
});

const shouldShowQuickActions = computed(() => process.client && userStore.isLoggedIn);

function openTrailer(title: PlotRecommenderTitleFragment) {
	ModalHelper.openModal(PlotRecommenderTrailerModal, {
		title,
		clip: title.content.clips[0],
		source: 'recommender-title-card',
	});
}

return { __sfc: true,props, userStore, isDescriptionExpanded, isMobileViewport, badgeColor, shouldShowQuickActions, openTrailer, GridBuyBox, PosterGraphql, BasicButton, faPlay }
}

})